import * as React from 'react';
const SvgPlus = (props) => (
   <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} {...props}>
      <g fill={props.fill ? props.fill : '#4A4A4A'} fillRule="nonzero">
         <path d="M28.154 26c1.02 0 1.846.895 1.846 2s-.827 2-1.846 2H15.846C14.826 30 14 29.105 14 28s.827-2 1.846-2z" />
         <path d="M40.154 26c1.02 0 1.846.895 1.846 2s-.827 2-1.846 2H27.846C26.826 30 26 29.105 26 28s.827-2 1.846-2z" />
         <path d="M28 26c1.105 0 2 .827 2 1.846v12.308c0 1.02-.895 1.846-2 1.846s-2-.827-2-1.846V27.847l.018-.251C26.151 26.695 26.988 26 28 26" />
         <path d="M28 14c1.105 0 2 .827 2 1.846v12.308c0 1.02-.895 1.846-2 1.846s-2-.827-2-1.846V15.846c0-1.02.895-1.846 2-1.846" />
      </g>
   </svg>
);
export default SvgPlus;
